// 接口定义

import i18n from "@/locales";

export interface MBTIType {
  type: string;
  name: string;
  nickname: string;
  description: string;
  traits: string[];
  image: string;
}

// 四个维度的选项
export const energyOptions = [
  { label: "E", value: "E", name: i18n.global.t("mbti.e") },
  { label: "I", value: "I", name: i18n.global.t("mbti.i") },
];

export const cognitionOptions = [
  { label: "S", value: "S", name: i18n.global.t("mbti.s") },
  { label: "N", value: "N", name: i18n.global.t("mbti.n") },
];

export const decisionOptions = [
  { label: "T", value: "T", name: i18n.global.t("mbti.t") },
  { label: "F", value: "F", name: i18n.global.t("mbti.f") },
];

export const lifestyleOptions = [
  { label: "J", value: "J", name: i18n.global.t("mbti.j") },
  { label: "P", value: "P", name: i18n.global.t("mbti.p") },
];

// MBTI 16种类型数据
export const mbtiTypes: MBTIType[] = [
  {
    type: "INTJ",
    name: i18n.global.t("mbti.intj.name"),
    nickname: i18n.global.t("mbti.intj.nickname"),
    description: i18n.global.t("mbti.intj.description"),
    traits: i18n.global.t("mbti.intj.traits").split(","),
    image: "/img/mbti/intj-architect-male.svg",
  },
  {
    type: "INTP",
    name: i18n.global.t("mbti.intp.name"),
    nickname: i18n.global.t("mbti.intp.nickname"),
    description: i18n.global.t("mbti.intp.description"),
    traits: i18n.global.t("mbti.intp.traits").split(","),
    image: "/img/mbti/intp-logician-female.svg",
  },
  {
    type: "ENTJ",
    name: i18n.global.t("mbti.entj.name"),
    nickname: i18n.global.t("mbti.entj.nickname"),
    description: i18n.global.t("mbti.entj.description"),
    traits: i18n.global.t("mbti.entj.traits").split(","),
    image: "/img/mbti/entj-commander-female.svg",
  },
  {
    type: "ENTP",
    name: i18n.global.t("mbti.entp.name"),
    nickname: i18n.global.t("mbti.entp.nickname"),
    description: i18n.global.t("mbti.entp.description"),
    traits: i18n.global.t("mbti.entp.traits").split(","),
    image: "/img/mbti/entp-debater-male.svg",
  },
  {
    type: "INFJ",
    name: i18n.global.t("mbti.infj.name"),
    nickname: i18n.global.t("mbti.infj.nickname"),
    description: i18n.global.t("mbti.infj.description"),
    traits: i18n.global.t("mbti.infj.traits").split(","),
    image: "/img/mbti/infj-advocate-male.svg",
  },
  {
    type: "INFP",
    name: i18n.global.t("mbti.infp.name"),
    nickname: i18n.global.t("mbti.infp.nickname"),
    description: i18n.global.t("mbti.infp.description"),
    traits: i18n.global.t("mbti.infp.traits").split(","),
    image: "/img/mbti/infp-mediator-female.svg",
  },
  {
    type: "ENFJ",
    name: i18n.global.t("mbti.enfj.name"),
    nickname: i18n.global.t("mbti.enfj.nickname"),
    description: i18n.global.t("mbti.enfj.description"),
    traits: i18n.global.t("mbti.enfj.traits").split(","),
    image: "/img/mbti/enfj-protagonist-male.svg",
  },
  {
    type: "ENFP",
    name: i18n.global.t("mbti.enfp.name"),
    nickname: i18n.global.t("mbti.enfp.nickname"),
    description: i18n.global.t("mbti.enfp.description"),
    traits: i18n.global.t("mbti.enfp.traits").split(","),
    image: "/img/mbti/enfp-campaigner-female.svg",
  },
  {
    type: "ISTJ",
    name: i18n.global.t("mbti.istj.name"),
    nickname: i18n.global.t("mbti.istj.nickname"),
    description: i18n.global.t("mbti.istj.description"),
    traits: i18n.global.t("mbti.istj.traits").split(","),
    image: "/img/mbti/istj-logistician-male.svg",
  },
  {
    type: "ISFJ",
    name: i18n.global.t("mbti.isfj.name"),
    nickname: i18n.global.t("mbti.isfj.nickname"),
    description: i18n.global.t("mbti.isfj.description"),
    traits: i18n.global.t("mbti.isfj.traits").split(","),
    image: "/img/mbti/isfj-defender-female.svg",
  },
  {
    type: "ESTJ",
    name: i18n.global.t("mbti.estj.name"),
    nickname: i18n.global.t("mbti.estj.nickname"),
    description: i18n.global.t("mbti.estj.description"),
    traits: i18n.global.t("mbti.estj.traits").split(","),
    image: "/img/mbti/estj-executive-female.svg",
  },
  {
    type: "ESFJ",
    name: i18n.global.t("mbti.esfj.name"),
    nickname: i18n.global.t("mbti.esfj.nickname"),
    description: i18n.global.t("mbti.esfj.description"),
    traits: i18n.global.t("mbti.esfj.traits").split(","),
    image: "/img/mbti/esfj-consul-male.svg",
  },
  {
    type: "ISTP",
    name: i18n.global.t("mbti.istp.name"),
    nickname: i18n.global.t("mbti.istp.nickname"),
    description: i18n.global.t("mbti.istp.description"),
    traits: i18n.global.t("mbti.istp.traits").split(","),
    image: "/img/mbti/istp-virtuoso-male.svg",
  },
  {
    type: "ISFP",
    name: i18n.global.t("mbti.isfp.name"),
    nickname: i18n.global.t("mbti.isfp.nickname"),
    description: i18n.global.t("mbti.isfp.description"),
    traits: i18n.global.t("mbti.isfp.traits").split(","),
    image: "/img/mbti/isfp-adventurer-female.svg",
  },
  {
    type: "ESTP",
    name: i18n.global.t("mbti.estp.name"),
    nickname: i18n.global.t("mbti.estp.nickname"),
    description: i18n.global.t("mbti.estp.description"),
    traits: i18n.global.t("mbti.estp.traits").split(","),
    image: "/img/mbti/estp-entrepreneur-male.svg",
  },
  {
    type: "ESFP",
    name: i18n.global.t("mbti.esfp.name"),
    nickname: i18n.global.t("mbti.esfp.nickname"),
    description: i18n.global.t("mbti.esfp.description"),
    traits: i18n.global.t("mbti.esfp.traits").split(","),
    image: "/img/mbti/esfp-entertainer-female.svg",
  },
];

export const getNameFromMbtiType = (type: string) => {
  const mbti = mbtiTypes.find((mbti) => mbti.type === type);
  return `${type}（${mbti?.name}）`;
};
